// Frontend stage definitions for the Proposal Pipeline Board.
// The string VALUES mirror api/src/stages.js exactly — keep them in sync. The API
// is the authority for validation; this file owns display (labels, grouping, order).

export const ACTIVE_STAGES = [
  { value: "tracking",            label: "Tracking" },
  { value: "presented_to_client", label: "Presented to Client" },
  { value: "pursuing",            label: "Pursuing" },
  { value: "drafting",            label: "Drafting" },
  { value: "draft_complete",      label: "Draft Complete" },
  { value: "final_review",        label: "Finalizing / Final Review" },
  { value: "submitted",           label: "Submitted" },
];

export const OUTCOME_STAGES = [
  { value: "selected",     label: "Selected" },
  { value: "funded",       label: "Funded" },
  { value: "not_selected", label: "Not Selected" },
  { value: "not_pursuing", label: "Not Pursuing" },
];

export const STAGES = [...ACTIVE_STAGES, ...OUTCOME_STAGES];
export const STAGE_VALUES = STAGES.map((s) => s.value);
export const STAGE_LABELS = Object.fromEntries(STAGES.map((s) => [s.value, s.label]));
export const STAGE_SET = new Set(STAGE_VALUES);
export const ACTIVE_STAGE_SET = new Set(ACTIVE_STAGES.map((s) => s.value));

export function isActiveStage(stage) {
  return ACTIVE_STAGE_SET.has(stage);
}

// A proposal's dueDate is its submission deadline, so due-date urgency (incl. "overdue")
// only applies while it is still pre-submission. Once "submitted" the deadline is met —
// it's awaiting a response, not late.
export function isPreSubmission(stage) {
  return ACTIVE_STAGE_SET.has(stage) && stage !== "submitted";
}

// Header accent per outcome column (active columns share the neutral accent).
export const OUTCOME_COLORS = {
  selected: "#3b82f6",     // award announced in our favor
  funded: "#10b981",       // contract executed
  not_selected: "#ef4444", // award against us
  not_pursuing: "#64748b", // declined
};

export const DEFAULT_NEW_STAGE = "tracking";

export function isValidStage(stage) {
  return STAGE_SET.has(stage);
}

export function stageLabel(stage) {
  return STAGE_LABELS[stage] || stage || "—";
}

// Legacy `status` -> `stage` (mirrors api/src/stages.js). Used only by the bridge
// in the old table UI during the increment 2->3 gap; the board sets stage directly.
export const LEGACY_STATUS_TO_STAGE = {
  "Submitted": "submitted",
  "Selected not Funded": "selected",
  "Funded": "funded",
  "Not Selected": "not_selected",
};

export function mapLegacyStatus(status) {
  return Object.prototype.hasOwnProperty.call(LEGACY_STATUS_TO_STAGE, status)
    ? LEGACY_STATUS_TO_STAGE[status]
    : null;
}
